import DynamicLayerEdit from '@/components/toolbox/geoobject/layers/dynamic'
import ObjectAssociations from '@/components/toolbox/geoobject/ObjectAssociations'

let getToolboxLayoutOfLayer = (layerId, objects) => {
  let tabs = {}

  tabs['edit'] = {
    title: 'Daten',
    tab: DynamicLayerEdit,
    icon: 'leerstand'
  }

  /* switch (layerId) {
    case 11: // leerstand
      tabs['edit'] = {
        title: 'Daten',
        tab: LeerstandLayerEdit,
        icon: 'leerstand'
      }
      break
    case 12: // secondred
      tabs['edit'] = {
        title: 'Daten',
        tab: SecondredLayerEdit,
        icon: 'secondred'
      }
      break
    default:
  } */

  if (typeof objects !== 'undefined' && objects.length > 0) {
    tabs['association'] = {
      title: `Verknüpft (${objects.length})`,
      tab: ObjectAssociations,
      icon: 'assoc'
    }
  }

  return tabs
}

export { getToolboxLayoutOfLayer }
